import PropTypes from 'prop-types';
import './currency';

export const ProductPresetGroupPropType = PropTypes.shape({
  productProfileId: PropTypes.string,
  name: PropTypes.string,
  weight: PropTypes.number,
  weightUnitOfMeasureId: PropTypes.string,
  length: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number,
  dimensionUnitOfMeasureId: PropTypes.string,
  providerId: PropTypes.string,
  serviceId: PropTypes.string,
  packageTypeId: PropTypes.string,
  confirmationId: PropTypes.string,
  intlProviderId: PropTypes.string,
  intlServiceId: PropTypes.string,
  intlPackageTypeId: PropTypes.string,
  intlConfirmationId: PropTypes.string,
  customsDescription: PropTypes.string,
  customsValue: PropTypes.number,
  currencyCustomsValue: PropTypes.shape({
    value: PropTypes.number,
    code: PropTypes.string,
  }),
  customsHarmonizationCode: PropTypes.string,
  customsCountry: PropTypes.string,
  noCustoms: PropTypes.bool,
});

/**
 * @typedef {object} ProductPresetGroup
 * @property {string} productProfileId
 * @property {string} name
 * @property {number} weight
 * @property {string} weightUnitOfMeasureId
 * @property {number} length
 * @property {number} width
 * @property {number} height
 * @property {string} dimensionUnitOfMeasureId
 * @property {string} providerId
 * @property {string} serviceId
 * @property {string} packageTypeId
 * @property {string} confirmationId
 * @property {string} intlProviderId
 * @property {string} intlServiceId
 * @property {string} intlPackageTypeId
 * @property {string} intlConfirmationId
 * @property {string} customsDescription
 * @property {number} customsValue
 * @property {CurrencyPropType} currencyCustomsValue
 * @property {string} customsHarmonizationCode
 * @property {string} customsCountry
 * @property {boolean} noCustoms
 */
